import React, { useEffect, useState } from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import { MenuItem, Select } from "@mui/material";
import { callAPI } from "../../../axios";
import { useDispatch } from "react-redux";
import { setChainIdLS } from "../../../utils/utils";
import { setViewTypeAction } from "../../../store/actions/GetViewType/SetViewTypeActions";

export const ChainIdSelectionPopup = (props) => {
  const dispatch = useDispatch();
  const { isOpen, closePopupHandler } = props;
  const [chainId, setChainId] = useState("");
  const [hotelList, setHotelList] = useState([]);

  useEffect(() => {
    if (isOpen) {
      callAPI(`master?type=HOTELS`, "GET")
        .then((response) => {
          setHotelList(response.data);
          setChainId(response?.data[0]?.code);
          setChainIdLS(response?.data[0]?.code);
          dispatch(setViewTypeAction(response?.data[0]?.viewType));
        })
        .catch((error) => console.warn(error));
    }
  }, [isOpen]);

  useEffect(() => {
    setChainIdLS(chainId);
    let viewType = hotelList.filter((item)=>item.code===chainId);
    dispatch(setViewTypeAction(viewType[0]?.viewType));
  }, [chainId])

  return (
    <BasicModal
      popupOpen={isOpen}
      bodyMessage={
        <>
          {/* <img src={deleteImg} alt="approve" className="w-40px" /> */}
          <div className="delete-banner-img mb-3">
            <p>Please Select Hotel?</p>
            <Select
              value={chainId}
              onChange={(e) => setChainId(e.target.value)}
              className="select-project"
            >
              {hotelList.map((hotel) => (
                <MenuItem key={hotel.code} value={hotel.code}>
                  {hotel.name}
                </MenuItem>
              ))}
            </Select>
          </div>
        </>
      }
      footer={{
        secondaryButton: {
          buttonName: "Proceed",
          action: closePopupHandler,
        },
      }}
    />
  );
};

export default ChainIdSelectionPopup;
